import React from 'react';

export const BackIcon = ({ ...props }) => (
  <svg width={6} height={10} fill="none" viewBox="0 0 6 10" {...props}>
    <path
      fill="#999"
      d="M1.243 5L5.455.643 4.833 0 0 5l4.833 5 .622-.682L1.243 5z"
    />
  </svg>
);
